// ProductModulesSection.jsx
import React from "react";
import "./ProductModulesSection.css";
import { motion } from "framer-motion";

const ProductModulesSection = ({ modules = [] }) => {
  return (
    <motion.section
      initial={{ opacity: 0, y: 80 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
      viewport={{ once: false, amount: 0.3 }}
    >
      <div className="modules-container">
        <h2 className="section-title-modules">PRODUCT MODULES</h2>
        <div className={`modules-grid ${modules.length === 5 ? 'grid-five-items' : ''}`}>
          {modules.map((module, index) => (
            <motion.div
              key={index}
              className="module-card"
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ delay: index * 0.1, duration: 0.5 }}
              viewport={{ once: false }}
            >
              <div className="icon-wrapper-product">
                <img src={module.icon} alt={module.title} />
              </div>
              <h3>{module.title}</h3>
              <p>{module.desc}</p>
              <p className="use-case">{module.useCase}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </motion.section>
  );
};

export default ProductModulesSection;